import dayjs from "dayjs";
import { CustomChip } from "../../../components/CustomChip/CustomChip";
import { translateSinisterStatus } from "../types";
import { TranslateFn } from "../../../utils/types";
import { ButtonsListSinister } from "./ButtonsListSinister";

/**
 * Colonnes de la liste des sinistres.
 *
 * Prend `t` en argument plutot que d'etre une constante de module : une
 * constante est evaluee une seule fois, a l'import, et resterait figee dans la
 * langue active au demarrage. Meme convention que getColumnsListVehicle.
 */
export const getColumnsClaimsList = (t: TranslateFn) => [
  { header: t("common.id", "ID"), field: "id" },
  { header: t("claims.sinisterName", "Claim name"), field: "name" },
  {
    header: t("common.date", "Date"),
    field: "",
    render: (rowData: Record<string, any>) => {
      return (
        <div>
          {rowData?.sinister_at &&
            dayjs(rowData.sinister_at).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  { header: t("vehicule.registration", "Registration"), field: "number" },
  { header: t("vehicule.mileage", "Mileage"), field: "mileage" },
  {
    header: t("vehicule.status", "Status"),
    field: "status",
    render: (rowData: Record<string, any>) => {
      return (
        <CustomChip
          // Traduction du CODE. C'etait la cle d'enum francaise renvoyee par
          // getSinisterKeyLabelByValue, d'ou "EN COURS" en session anglaise.
          label={translateSinisterStatus(t, rowData?.sinister_status)}
          value={rowData?.sinister_status}
        />
      );
    },
  },
  {
    header: "",
    field: "",
    render: (rowData: Record<string, any>) => {
      return <ButtonsListSinister sinister={rowData as TSinister} />;
    },
  },
];
